export enum UserRoles {
  Administrator = 'Administrator'
}
